var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"field"},[(_vm.label)?_c('field-label',_vm._b({},'field-label',{
    required: _vm.required,
    requiredClass: _vm.requiredClass,
    requiredText: _vm.requiredText,
    hint: _vm.hint,
    hintIcon: _vm.hintIcon,
    hintIconPack: _vm.hintIconPack,
    hintIconType: _vm.hintIconType,
    hintClass: _vm.hintClass,
    description: _vm.description
  },false),[_vm._t("default")],2):_vm._e(),(_vm.description)?_c('p',{class:['field-description', _vm.descriptionClass]},[_vm._v(_vm._s(_vm.description))]):_vm._e(),_c(_vm.element,{ref:"editor",tag:"component",domProps:{"innerHTML":_vm._s(_vm.value)}}),(_vm.hasError)?_c('field-error',_vm._b({},'field-error',{ error: _vm.error, errorClass: _vm.errorClass, errorSymbol: _vm.errorSymbol },false)):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }